import React, { useEffect, useState, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import PropTypes from 'prop-types';
import { Container, Row, Col } from 'react-bootstrap';

import Skeleton from '../../components/skeleton/Skeleton';
import BlogList from '../../components/BlogList';
import Pagination from '../../components/Pagination';
import RightSidebar from '../../components/RightSidebar';
import useToken from '../../hooks/useToken';
import { API_ENDPOINTS } from '../../utils/config';
import Categories from '../../components/Categories';

import sectionGreenBg from '../../assets/images/section-green.webp';
import wrapCenterBg from '../../assets/images/wrap-center.webp';

const POSTS_PER_PAGE = 10;

const Listing = ({ type }) => {
    const { slug } = useParams(); 
    const { token } = useToken(); 
    const searchParam = new URLSearchParams( window.location.search ).get( 's' );

    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    
    const fetchPosts = useCallback(async () => {
        setIsLoading(true);

        const taxonomyParam = type !== 'blog' ? `&${type}=${slug}` : '';
        const searchQuery = searchParam ? `&s=${searchParam}` : '';
        const queryParams = `${taxonomyParam}${searchQuery}`;
        const url = `${API_ENDPOINTS.POSTS_ENDPOINT}?paged=${currentPage}&per_page=${POSTS_PER_PAGE}${queryParams}`;

        const headers = {
            'Content-Type': 'application/json; charset=UTF-8',
            Authorization: `Bearer ${token}`
        };

        try {
            const { data, status } = await axios.get(url, { headers });

            if ( status === 200 ) {
                setPosts( data.items || [] );
                const total = parseInt( data.total_posts || 0, 10 );
                setTotalPages( Math.ceil( total / POSTS_PER_PAGE ) );
            } else {
                setPosts([]);
            }
        } catch ( error ) {
            console.error( 'Error fetching posts:', error );
            setPosts([]);
        } finally {
            setIsLoading( false );
        }
    }, [currentPage, token, slug, type, searchParam]);

    const handlePageChange = ( page ) => {
        setCurrentPage( page );
    };

    useEffect(() => {
        fetchPosts(); // eslint-disable-next-line	
    },[fetchPosts])

    return (
        <>
            <section
            id="blog-page"
            className="section"
            style={{ backgroundImage: `url(${wrapCenterBg})` }}
            >
                <div
                    className="section-decoration top"
                    style={{
                        backgroundImage: `url(${sectionGreenBg})`,
                        height: '35px',
                        backgroundColor: '#fffff'
                    }}
                />
                
                <Container>
                    <div className="content-area mb-3">
                        <Categories />
                    </div>
                    <Row className="mt-5">
                        <Col className="col-lg-9 col-md-12 col-left-custom wow fadeInUp">
                            { isLoading ? <Skeleton type="blog" /> : <BlogList data={posts} /> }
                            {totalPages > 1 && (
                                <Pagination
                                    currentPage={currentPage}
                                    totalPages={totalPages}
                                    onPageChange={handlePageChange}
                                />
                            )}
                        </Col>
                        <Col className="col-lg-3 col-md-12 col-right-custom wow fadeInUp">
                            <RightSidebar />
                        </Col>
                    </Row>
                </Container>
            </section>
        </> 
    );
};

Listing.propTypes = {
    type: PropTypes.string.isRequired
};

export default Listing;